export const getCurrentMonthRange = () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    const formatDateStr = (date) => date.toISOString().split('T')[0];

    return {
        start: formatDateStr(firstDay),
        end: formatDateStr(lastDay)
    };
};